import { Formik } from 'formik';
import { initialValuesInvitations, validationSchemaInvitations } from './InvitationsValidationForm';
import Form from "./InvitationForms";
import { useAxios } from '../../../context/AxiosHookContext';
import { useNotification } from '../../../context/NotificationContext';

const FormCreateInvitation = ({ valuesToEdit, onClose, getValues }) => {

    const axios = useAxios();
    const { showSnackbar } = useNotification();

    const handleSubmit = async (invitation) => {

        try {

            if (invitation._id) {

                await axios.put(`/invitations/update/${invitation._id}`, invitation)

            } else {

                await axios.post(`/invitations/create`, invitation)
            }
            showSnackbar({ severity: "success", title: "Invitación", message: "Se ha actualizado la invitación de forma exitosa." });

            getValues();

        } catch (error) {
            const message = error?.response?.data?.message || "Ha ocurrido un error al crear la invitación."
            showSnackbar({ severity: "error", title: "Invitación", message })
        }

    }

    const getInitialValues = () => {
        return (valuesToEdit && Object.keys(valuesToEdit).length) > 0 ? valuesToEdit : initialValuesInvitations
    }
    
    return (
        <Formik
            validationSchema={validationSchemaInvitations}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}
        >
            <>
                <Form onClose={onClose} />
            </>
        </Formik>
    )
}

export { FormCreateInvitation }